module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_1@2x.78e69295.png";